import { AssetCard } from './cards/AssetCard';
import { CardErrorBoundary } from './cards/CardErrorBoundary';
import { formatDisplayShort } from '../../../lib/dateUtils';
import { snakeToTitleCase, isQuickPassAllowed, getQuickPassTooltip } from '../../../lib/sessionGroupingUtils';

/**
 * Controlled list of asset cards for a single session group.
 *
 * Renders the shared `<AssetCard>` prop contract (previously duplicated across
 * the desktop pane, desktop group-cards, and mobile views). Purely presentational:
 * it owns no state and performs no data fetching, mutations, or store writes —
 * every action is forwarded to the parent via callbacks.
 */
export function SessionAssetList({
  items,
  results,
  sessionAssetType,
  sessionTestType,
  sessionTestDate,
  isExitEmergency,
  isSyncing,
  rcdInputs,
  setRcdInput,
  dualCheckInputs = {},
  setDualCheckInput,
  handleQuickPass,
  openEditModal,
  openFailEditModal,
}) {
  return (
    <>
      <ul className="asset-card-list">
        {items.map((asset) => (
          <CardErrorBoundary key={asset.id} assetId={asset.id}>
            <AssetCard
              asset={asset}
              sessionEntry={results[asset.id]}
              sessionAssetType={sessionAssetType}
              showTypeBadge={
                (sessionAssetType === 'combined_exit_emergency' ||
                  sessionAssetType === 'combined_db_rcd' ||
                  sessionAssetType === 'combined_fan_heater' ||
                  sessionAssetType === 'workshop_equipment') &&
                !!asset.asset_type
              }
              typeLabel={
                (asset.asset_type || '').toLowerCase() === 'workshop_equipment'
                  ? (asset.item_type || asset.extra_details?.item_type || 'Workshop Equipment')
                  : snakeToTitleCase(asset.asset_type)
              }
              formatDisplayShort={formatDisplayShort}
              isSyncing={isSyncing}
              sessionTestType={sessionTestType}
              sessionTestDate={sessionTestDate}
              isExitEmergency={isExitEmergency}
              rcdInput={rcdInputs[asset.id] ?? { pushButton: null, tripTimeMs: '' }}
              rcdEntered={rcdInputs[asset.id] != null}
              setRcdInput={setRcdInput}
              dualCheckInput={dualCheckInputs[asset.id]}
              setDualCheckInput={setDualCheckInput}
              handleQuickPass={handleQuickPass}
              openEditModal={openEditModal}
              openFailEditModal={openFailEditModal}
              isQuickPassAllowed={isQuickPassAllowed}
              getQuickPassTooltip={getQuickPassTooltip}
            />
          </CardErrorBoundary>
        ))}
      </ul>
    </>
  );
}
